import { DEFAULT_FONT_FAMILY, DEFAULT_FONT_SIZE, DEFAULT_SHAPE_FILL, DEFAULT_SHAPE_STROKE, DEFAULT_SHAPE_STROKE_WIDTH, DEFAULT_TEXT_FILL, } from '../constants.js';
import { connectorPoints, layoutNodes, totalBounds } from './layout.js';
let _idCounter = 0;
const nextId = (prefix) => `${prefix}_${Date.now().toString(36)}_${_idCounter++}`;
const styleToPaint = (n) => {
    const fill = n.style?.fill ?? DEFAULT_SHAPE_FILL;
    const stroke = n.style?.stroke ?? DEFAULT_SHAPE_STROKE;
    const strokeWidth = Number(n.style?.strokeWidth ?? DEFAULT_SHAPE_STROKE_WIDTH);
    const textColor = n.style?.textColor ?? DEFAULT_TEXT_FILL;
    return { fill, stroke, strokeWidth, textColor };
};
export const renderToCanvas = (model) => {
    const positions = layoutNodes(model);
    const elements = [];
    const mermaidIdToElId = new Map();
    const connectorSpecs = [];
    for (const n of model.nodes) {
        const pos = positions.get(n.id);
        if (!pos)
            continue;
        const paint = styleToPaint(n);
        const id = nextId('el');
        mermaidIdToElId.set(n.id, id);
        const base = {
            id,
            x: pos.x,
            y: pos.y,
            width: pos.width,
            height: pos.height,
            rotation: 0,
            fill: paint.fill,
            stroke: paint.stroke,
            strokeWidth: paint.strokeWidth,
            textColor: paint.textColor,
            fontSize: n.style?.fontSize ?? DEFAULT_FONT_SIZE,
            fontFamily: n.style?.fontFamily ?? DEFAULT_FONT_FAMILY,
            text: n.label,
            mermaidId: n.id,
            parentId: n.parent,
            zIndex: 1,
        };
        elements.push({ ...base, type: n.shape ?? 'rect' });
    }
    for (const e of model.edges) {
        const spec = connectorPoints(positions, e.from, e.to);
        if (!spec)
            continue;
        connectorSpecs.push({ edgeId: e.id, fromId: e.from, toId: e.to, spec, label: e.label, style: e.style });
    }
    for (const { edgeId, fromId, toId, spec, label, style } of connectorSpecs) {
        if (!spec)
            continue;
        const points = routeConnector(spec, positions, model, edgeId);
        const isArrow = (label ?? '').trim().length > 0 ? true : true;
        const dash = style === 'dashed' ? [8, 6] : style === 'dotted' ? [2, 4] : undefined;
        const strokeWidth = style === 'thick' ? 3 : DEFAULT_SHAPE_STROKE_WIDTH;
        const conn = {
            id: nextId('cn'),
            type: isArrow ? 'arrow' : 'line',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            rotation: 0,
            stroke: DEFAULT_SHAPE_STROKE,
            strokeWidth,
            dash,
            label,
            points,
            source: { elementId: mermaidIdToElId.get(fromId), anchor: 'auto' },
            target: { elementId: mermaidIdToElId.get(toId), anchor: 'auto' },
            zIndex: 0,
        };
        elements.push(conn);
    }
    const bounds = totalBounds(positions, connectorSpecs.filter((c) => c.spec).map((c) => c.spec));
    return { elements, bounds };
};
const routeConnector = (spec, _positions, _model, _edgeId) => {
    if (!spec)
        return [];
    if (spec.routed === 'orthogonal' && Math.abs(spec.x1 - spec.x2) > 10 && Math.abs(spec.y1 - spec.y2) > 10) {
        // simple orthogonal: out from source horizontally, midway to target, then into target horizontally
        const midX = (spec.x1 + spec.x2) / 2;
        return [spec.x1, spec.y1, midX, spec.y1, midX, spec.y2, spec.x2, spec.y2];
    }
    return [spec.x1, spec.y1, spec.x2, spec.y2];
};
//# sourceMappingURL=render.js.map